
import React from 'react';
import Show from '../Show/Show';
import { Body1Reg, Body2Bold, Title2 } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { SPACING } from '../../config/designSystem/Spacing';
import { SolarFlowerIcon } from '../../assets/images/solar/flower/Flower';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';

export type SectionTitleProps ={
    title: string,
    subtitle?: string,
    displayAll: boolean,
    onTouchDisplayAll?: () => void,
    flowerColor?: string,
    style?: StyleProp<ViewStyle>
}

const _SectionTitle = ( {flowerColor , title, subtitle, displayAll,onTouchDisplayAll,style} : SectionTitleProps) => {

  const { language} = useStores();
  const labels = language.translate.MOBILE.DASHBOARD;




  return(<View style={style}>
    <View style={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'}}>
      <View style={[displayAll && { maxWidth: '70%' }, {minWidth: 100,  flexDirection:'row', alignItems:'center'}]}>
        <Show when={!!flowerColor}>
          <View style={{marginRight: SPACING['sp-8']}}>
            <SolarFlowerIcon size={32} color={flowerColor} />

          </View>
        </Show>
        <Title2>{title}</Title2>
      </View>
      <Show when={displayAll}>
        <View style={{ maxWidth: '25%',  marginRight: SPACING['sp-16'] }}>
          <TouchableOpacity
            onPress={onTouchDisplayAll}
          >
            <Body2Bold color={COLORS.content.tertiary}>{labels.DISPLAY_ALL}</Body2Bold>
          </TouchableOpacity>
        </View>

      </Show>
    </View>
    <Show when={subtitle && subtitle.length > 0}>
      <View style={{marginTop: SPACING['sp-8']}}>
        <Body1Reg color={COLORS.content.tertiary}>{subtitle}</Body1Reg>
      </View>
    </Show>
  </View>

  );

};

export const SectionTitle = observer(_SectionTitle);
